import {SYSTEMSETTING} from 'Constants/ActionTypes';

const {
  GET_WORK_TIME_LIST,
  SET_WORK_TIME_PAGE_STATUS,
  DELETE_WORK_TIME,
  SET_WORK_TIME_EDIT_MODAL_DATA,
  GET_WORK_TIME_EDIT_MODAL_DATA,
  EDIT_WORK_TIME,
} = SYSTEMSETTING;
// 通用前缀
const url = '/robot';

const actions = {
  // 系统设置-工作时间-列表
  getTableList(data) {
    return {
      type: GET_WORK_TIME_LIST,
      payload: {
        request: {
          method: 'post',
          url: `${url}/worktime/list`,
          data,
        },
      },
    };
  },
  // 系统设置-工作时间-设置pageNum与pageSize
  setPageStatus(data) {
    return {
      type: SET_WORK_TIME_PAGE_STATUS,
      data,
    };
  },
  // 系统设置-工作时间-删除
  deleteWorkTime(data) {
    return {
      type: DELETE_WORK_TIME,
      payload: {
        request: {
          method: 'delete',
          url: `${url}/worktime/delete`,
          data,
        },
      },
    };
  },
  // 系统设置-工作时间-设置编辑弹框数据
  setEditModalData(data) {
    return {
      type: SET_WORK_TIME_EDIT_MODAL_DATA,
      data,
    };
  },
  // 系统设置-工作时间-获取编辑弹框数据
  getEditModalData(id) {
    return {
      type: GET_WORK_TIME_EDIT_MODAL_DATA,
      payload: {
        request: {
          method: 'get',
          url: `${url}/worktime/${id}`,
        },
      },
    };
  },
  // 系统设置-工作时间-编辑弹框-点击确定
  editWorkTime(data) {
    return {
      type: EDIT_WORK_TIME,
      payload: {
        request: {
          method: 'post',
          url: `${url}/worktime/upsert`,
          data,
        },
      },
    };
  },
};

export default actions;
